<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class=" d-flex justify-content-between align-items-center p-2">
                <div class="settlement-title p-2">Settlements</div>
                <button @click="toggleFilter">
                    <img class="search-icon" src="@/assets/images/icon/search.png" />
                </button>
            </div>
            <div class="mt-4 p-2" v-if="hasResults">
                <template v-for="(settlements, date) in groupedSettlements" :key="date">
                <div  v-for="(item, index) in settlements" :key="index" @click="openDetail(item)" >
                  <div class="col-item d-flex justify-content-between align-items-center mt-2" >
                    <div>
                        <div class="col-date">{{ format(item.created_at) }}</div>
                        <div class="col-ref mt-1">Ref: {{ item.settlement_ref }}</div>
                    </div>
                    <div>
                        <div class="col-pay">{{ formatCurrency(item.total_amount) }}</div>
                        <div class="col-status" :class="item.payment_status == 'Settled' ? 'text-green': ''" >{{ item.payment_status }}</div>
                    </div> 
                  </div>
                </div>
              </template>
            </div>
            <div class="p-2 no-result" v-else>
              <div class="no-result-text">No results found</div>
              <div class="search-again" @click="toggleFilter()">Search again</div>
            </div>
            <div class="mt-5 mb-5">&nbsp;</div>
        </div>
    </div>

    <div class="pagination-container"  v-if="!showDetail">
        <div class="pagination-left">
            <button @click="changePage(1)" :disabled="settlementStore.currentPage === 1">
            <img src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" class="arrow-icon" />
            </button>
            <button @click="changePage(settlementStore.currentPage - 1)" :disabled="settlementStore.currentPage === 1">
            <img src="@/assets/images/admin/arrow/prev.png" alt="Prev" class="arrow-icon" />
            </button>
        </div>
        
        <div class="pagination-center">
            <span class="page-info">
            Page 
            <input type="number" v-model.number="settlementStore.currentPage" @change="changePage(settlementStore.currentPage)" class="page-input" />
            of {{ totalPages }}
            </span>
        </div>
        
        <div class="pagination-right">
            <button @click="changePage(settlementStore.currentPage + 1)" :disabled="settlementStore.currentPage === totalPages">
            <img src="@/assets/images/admin/arrow/next.png" alt="Next" class="arrow-icon" />
            </button>
            <button @click="changePage(totalPages)" :disabled="settlementStore.currentPage === totalPages">
            <img src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" class="arrow-icon" />
            </button>
        </div>
    </div>  
    <Search 
      v-if="filterVisible"
      @search="search"
      @close="toggleFilter"
    />  
    <Detail 
      v-if="showDetail"
      :initialIndex="selectedIndex"
      @close="closeDetail"
     />

    

</template>

<script setup>
import { ref,onMounted,computed } from 'vue';
import { useSettlementStore } from '@/store/driver/settlement';
import { useTransactionStore } from '@/store/driver/transaction';
import Detail from './detail.vue';
import Search from './search.vue';
import {onBeforeRouteLeave } from 'vue-router';


const settlementStore = useSettlementStore();
const transactionStore = useTransactionStore();

// 控制 Detail 組件顯示的狀態
const showDetail = ref(false);
const selectedIndex = ref(null);

const filterVisible = ref(false);

const hasResults = computed(() => settlementStore.totalEntries > 0);
// 將資料根據日期進行分組
const groupedSettlements = computed(() => {
  return settlementStore.settlements.reduce((acc, settlement) => {
    const date = settlement.created_at.split(' ')[0]; // 取得日期部分
    if (!acc[date]) acc[date] = [];
    acc[date].push(settlement);
    return acc;
  }, {});
})

;const totalPages = computed(() => settlementStore.totalPages);

const flattenedSettlements = computed(() => settlementStore.settlements);

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const changePage =  async (page) => {
  settlementStore.currentPage = page;
  await settlementStore.fetchSettlements(page,10);
};

const format = (dateString) => {
  const date = new Date(dateString); // 將日期字串轉換為 Date 物件
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  // 使用一個月份名稱的陣列來取得月份名稱
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[date.getMonth()]; // 取得月份名稱

  return `${day} ${month} ${year}`;
};


const formatCurrency = (value) => {
  const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

const search = async () => {
  settlementStore.currentPage = 1;
  await settlementStore.fetchSettlements();
  toggleFilter();

};

// 點擊交易項目以打開 Detail 組件
const openDetail = (settlement) => {
  const index = settlementStore.settlements.findIndex(
    (item) => item.id === settlement.id
  );
  selectedIndex.value = index;
  showDetail.value = true;
};

// 關閉 Detail 組件
const closeDetail = () => {
  showDetail.value = false;
  selectedIndex.value = null;
};

// 使用 onBeforeRouteLeave 鉤子來清空篩選條件
onBeforeRouteLeave(() => {
  // 清空篩選條件
  settlementStore.filters.fromDate = '';
  settlementStore.filters.toDate = '';
  settlementStore.filters.reference = '';

  transactionStore.shouldResetFilters = true;
  settlementStore.currentPage = 1;
});

onMounted(async () => {
  changePage(1);
  await settlementStore.fetchSettlements();

});

</script>

<style scoped>

.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 90%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
    border-radius: 10px 10px 0px 0px;
}

.settlement-title{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.search-icon{
    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    gap: 10px;

    width: 36px;
    height: 36px;

    /* Grey 10% */
    background: #EEF1F4;
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;
    cursor: pointer;
}

.col-item{
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #99A6B4;
}

.col-date{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    color: #1E1E2D;
}

.col-ref{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #5E707D;
}

.col-pay{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #051C2C;
}

.col-status{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: right;
}

.text-green{
    color: #00c962;
}


.no-result {
  margin-top: 20px;
  background-color: #d9d9d9;
  border-radius: 12px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center; /* 確保文字居中 */
  padding: 20px; /* 增加一點內距來保持美觀 */
}

.no-result-text {
  font-family: 'Euclid Square';
  font-style: italic;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  color: #051C2C;
  margin-bottom: 8px; /* 與 search-again 保持距離 */
}

.search-again {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #5248DA;
  cursor: pointer; /* 可選：讓文字像按鈕一樣具有可點擊效果 */
}


/* Pagination section 固定在底部 */
.pagination-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10vh;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px -2px 15px rgba(5, 28, 44, 0.15);
  border-radius: 12px 12px 0px 0px;
  z-index: 1;
}

.pagination-left,
.pagination-right {
  display: flex;
}

.pagination-center {
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 28px;
  height: 28px;
}

.page-info {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-input {
  width: 40px;
  height: 30px;
  text-align: center;
  font-size: 16px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0 5px;
}

button {
  border: none;
  background: none;
  cursor: pointer;
}


</style>

